































import { Vue, Component } from "vue-property-decorator";
import { LogService } from "./log.service";
import { DetectState } from "@/pages/detect/_state";
import { LogStore, LOG_ACTIONS } from "./log.store";
@Component
export default class LogDetectSetp1 extends Vue {
  @LogStore.Action(LOG_ACTIONS.LOAD_DETECTIONS) loadDetections: any;

  form = {
    archive: "",
    appProgressMap: "",
    phoneDeviceInfo: ""
  };
  errors = {
    archive: "",
    appProgressMap: "",
    phoneDeviceInfo: ""
  };

  submitLoading = false;

  get hasError() {
    const { archive, appProgressMap, phoneDeviceInfo } = this.errors;
    return !archive && !appProgressMap && !phoneDeviceInfo;
  }

  get valid() {
    const { archive, appProgressMap, phoneDeviceInfo } = this.form;
    return archive && appProgressMap && phoneDeviceInfo && !this.hasError;
  }

  async onSubmit() {
    this.submitLoading = true;
    try {
      await LogService.createLogDetection(this.form).then(e => {
        DetectState.waitingDetection = e;
        this.loadDetections();
        this.submitLoading = false;
      });
    } catch {
      this.submitLoading = false;
      this.$notify.error({
        title: "提交检测失败",
        message: ""
      });
    }
  }
}
